<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
  }
  }
}
</script>

<style>
  @import 'normalize.css';
  @import 'app.less';
</style>



// WEBPACK FOOTER //
// src/App.vue